const state = {
    soundtrackClipState: false,//剪辑框打开状态
    cutMusic: {},//当前剪辑的音乐数据
    clipMusicTime: false,
    clipDubing: false,
    clipState: {},
}
const getters = {
    getsoundtrackClipState: state => state.soundtrackClipState,
    getCutMusic: state => state.cutMusic,
    getClipState: state => state.clipState,
}
const mutations = {
    setsoundtrackClipState(state, data) {
        state.soundtrackClipState = data;
    },
    // 当前剪辑的音乐对象
    setCutMusic(state, data) {
        state.cutMusic = data;
    },



}
export default {
    namespaced: true,
    state,
    getters,
    mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/soundtrackSet.js